export enum PaymentType {
  CC = 'gene_braintree_creditcard',
  CC_Bluesnap = 'bluesnap_cc',
  ACH_Bluesnap = 'bluesnap_ach',
  BE = 'budgetentities',
  GiftCard = 'giftcard',
  ACH = 'braintree_ach',
  PO = 'purchaseorder',
  FREE = 'free',
}
